import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import classname from 'classnames';

import ModalRoot from 'components/Modal/ModalRoot';
import Campaign from '../containers/Campaign';

export class Home extends Component {
  render() {
    const { classes, campaigns, clientName } = this.props;

    return (
      <div className={classes.content}>
        <div className={classes.topContainer}>
          <Typography className={classes.title} variant="h6" gutterBottom>
            {clientName}
          </Typography>
          <Button
            variant="contained"
            size="small"
            color="primary"
            component={Link}
            to="/dashboard/create/cms/new"
          >
            create new campaign
          </Button>
        </div>

        <div className={classes.paper}>
          <div className={classes.campaignsTopContainer}>
            <span className={classes.campaignTitle}>campaigns</span>
            <div className={classes.statusContainer}>
              <span className={classes.statusTitle}>status:</span>
              <div className={classname(classes.status, classes.active)} />
              <span className={classes.statusText}>active</span>
              <div className={classname(classes.status, classes.inactive)} />
              <span className={classes.statusText}>inactive</span>
            </div>
          </div>
          <div className={classes.campaignsBodyContainer}>
            {campaigns &&
              campaigns &&
              campaigns.map(campaign => {
                return (
                  <Campaign
                    key={campaign._id}
                    campaign={campaign}
                    onClick={() =>
                      this.props.history.push(`/dashboard/create/cms/${campaign._id}`)
                    }
                  />
                );
              })}
          </div>
        </div>
        <ModalRoot />
      </div>
    );
  }
}

const styles = theme => ({
  content: {
    backgroundColor: '#F4F8F9',
    flexGrow: 1,
    overflowX: 'hidden',
    overflowY: 'scroll',
    padding: theme.spacing(2),
  },
  topContainer: {
    display: 'flex',
    flexWrap: 'nowrap',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  paper: {
    padding: 20,
    marginTop: 15,
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    background: '#FFFFFF',
    borderRadius: 4,
    // boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
    transition: 'all 0.3s cubic-bezier(.25,.8,.25,1)',
  },
  campaignsTopContainer: {
    display: 'flex',
    flexWrap: 'nowrap',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginLeft: theme.spacing(),
    marginRight: theme.spacing(),
    marginBottom: theme.spacing(),
  },
  campaignsBodyContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
  },
  title: {
    ...theme.Typography,
    color: '#044591',
    paddingBottom: theme.spacing(),
  },
  campaignTitle: {
    color: '#000',
    textTransform: 'uppercase',
    fontSize: '0.9em',
    fontWeight: 'bold',
  },
  statusContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  statusTitle: {
    color: '#AAAAAA',
    textTransform: 'uppercase',
    fontSize: '0.65em',
    fontWeight: 'regular',
    paddingRight: 10,
  },
  status: {
    borderRadius: '50%',
    width: 10,
    height: 10,
    marginRight: 3,
  },
  active: {
    backgroundColor: '#7ED321',
  },
  inactive: {
    backgroundColor: '#EC5E3C',
  },
  statusText: {
    color: '#AAAAAA',
    textTransform: 'uppercase',
    fontSize: '0.7em',
    fontWeight: 'regular',
    paddingRight: 10,
  },
});

export default withStyles(styles)(Home);
